import { lazy } from 'react';
import { RouteObject } from 'react-router';

import { IntegrationSystem } from '@/shared/types';

import { createSystemRoutes, RoutesBySystem } from '@/router/utils';

import { ARS_ROUTES } from './config';

const CitizenAppealToMvs = lazy(() => import('../pages/services/CitizenAppealToMvs'));
const SearchIncomingCorrespondence = lazy(() => import('../pages/services/SearchIncomingCorrespondence'));

export const arsSystemComponents: Record<
  keyof RoutesBySystem<IntegrationSystem.ARS>,
  React.LazyExoticComponent<React.FC<any>>
> = {
  CITIZEN_APPEAL_TO_MVS: CitizenAppealToMvs,
  SEARCH_INCOMING_CORRESPONDENCE: SearchIncomingCorrespondence,
};

export const ARSRoutes: RouteObject = createSystemRoutes(IntegrationSystem.ARS, ARS_ROUTES, arsSystemComponents);
